// extracted by mini-css-extract-plugin
module.exports = {"searchInput":"NotesTab_searchInput__2Kelg","addNoteButton":"NotesTab_addNoteButton__3aAxc"};